import { render, staticRenderFns } from "./ChatController.vue?vue&type=template&id=c1938548&"
import script from "./ChatController.vue?vue&type=script&lang=js&"
export * from "./ChatController.vue?vue&type=script&lang=js&"
import style0 from "./ChatController.vue?vue&type=style&index=0&id=c1938548&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports